const { handleRandomImage } = require('../utils')
module.exports = [
  {
    url: '/carApplications/list',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          pn: 1,
          size: 10,
          total: 1,
          list: [
            {
              car_application_id: '613988053580514187',
              application_number: 'DYW20240328000003',
              applicant_name: '赵钱来',
              applicant_gender: 0,
              applicant_face_photo: handleRandomImage(),
              visitor_idcard_type: 1,
              applicant_idcard: '441881199901016469',
              applicant_phone: '13888888880',
              visitor_company: '来访单位-五',
              visitor_type: 1,
              visitor_content: '测试事由',
              visitor_begin_time: '2024-04-01',
              visitor_end_time: '2024-04-07',
              visit_area: 3,
              interviewee_depart_id: '828735811590553600',
              interviewee_name: '大亚湾区公安局',
              interviewee_phone: '13666666669',
              state: 0,
              create_user_id: '100',
              create_time: '2024-03-28 14:57:27',
              update_time: '2024-03-28 14:57:27',
              license_plate: '粤L88299',
              is_delayed: 0,
              delay_reason: '',
              process_instance_id: 0,
              is_deleted: 0,
              wx_unionid: '',
            },
          ],
        },
      }
    },
  },
  {
    url: '/carApplications/detail',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          car_application_id: '613677798938117085',
          application_number: 'DYW20240327000001',
          applicant_name: '李四娃',
          applicant_gender: 1,
          applicant_face_photo: handleRandomImage(),
          visitor_idcard_type: 1,
          applicant_idcard: '441881199901016469',
          applicant_phone: '13888888880',
          visitor_company: '来访单位-第二版',
          visitor_type: 1,
          visitor_content: '测试事由-第二版',
          visitor_begin_time: '2024-03-28',
          visitor_end_time: '2024-03-30',
          visit_area: 3,
          interviewee_depart_id: '828735811590553600',
          interviewee_name: '大亚湾区公安局',
          interviewee_phone: '13666666666',
          state: 1,
          create_user_id: '100',
          create_time: '2024-03-27 18:24:36',
          update_time: '2024-03-28 00:00:00',
          cargo_type: 1,
          license_plate: '粤L88888',
          is_delayed: 0,
          delay_reason: '',
          process_instance_id: 0,
          is_deleted: 0,
          wx_unionid: '',
          car_info_id: '613677799022003638',
          vehicle_type_id: '0',
          color_id: 1,
          vehicle_img: handleRandomImage(),
          vehicle_license_number: '123456789',
          engine_number: '1234567',
          car_load: '50',
          cargo_name: '固态二氧化硫-第二版',
          remark: '无',
          driver_info: [
            {
              car_person_id: '613677799022003639',
              application_number: 'DYW20240327000001',
              name: '司机1',
              gender: 0,
              idcard_type: 1,
              phone: '13344444442',
              id_card: '441881199901016401',
              face_photo: handleRandomImage(),
              pqc_number: '124326268',
              type: 1,
              create_time: '2024-03-27 18:24:36',
              update_time: '2024-03-28 00:00:00',
              deleted: 0,
            },
            {
              car_person_id: '613979247773486644',
              application_number: 'DYW20240327000001',
              name: '押运员2',
              gender: 0,
              idcard_type: 2,
              phone: '13344444444',
              id_card: '441881199901016421',
              face_photo: handleRandomImage(),
              pqc_number: '124326279',
              type: 2,
              create_time: '2024-03-28 00:00:00',
              update_time: '2024-03-28 00:00:00',
              deleted: 0,
            },
          ],
          cargo_info: {
            car_manifest_id: '613677799068142938',
            application_number: 'DYW20240327000001',
            cargo_number: 'fgb1234567',
            cargo_name: '固态二氧化硫-第二版',
            cargo_quantity: '50',
            cargo_unit: '吨',
            enterprise: '大运速递',
            unified_social_credit_code: 'da123456',
            business_license_number: 'd124356',
            contact_phone: '13555555555',
            license_plate_color: '蓝色',
            vehicle_transport_license: 's1235252352',
            trailer_license: '挂123435',
            trailer_trasport_license: 'sd12435346',
            tank_volume: '',
            tank_report: '',
            driver: '司机',
            driver_qualification_certificate: '12432626',
            driver_phone: '13344444444',
            supercargo: '押运员',
            supercargo_qualification_certificate: '1235252626',
            supercargo_phone: '13455555555',
            shipper: '托运员',
            shipper_phone: '13566666666',
            recipient: '收货人六术',
            recipient_phone: '13666666666',
            carrier: '装货人',
            carrier_phone: '13666666666',
            shipment_date: '2023-12-28 00:00:00',
            shipment_addr: '广东省危险品基地',
            destination: '广东省惠州市大亚湾区石化园区3号',
            annex: handleRandomImage(),
            deleted: 0,
          },
        },
      }
    },
  },
]
